import { render, staticRenderFns } from "./Fotter.vue?vue&type=template&id=e8513c20"
import script from "./Fotter.vue?vue&type=script&lang=js"
export * from "./Fotter.vue?vue&type=script&lang=js"
import style0 from "./Fotter.vue?vue&type=style&index=0&id=e8513c20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports